import { createStore } from 'vuex'
import createPersistedState from 'vuex-persistedstate'
import auth from './auth'
import sideNav from "./sideNav";
import news from "./news";
import promotion from "./promotion";

const store = createStore({
    plugins:[
        createPersistedState()
    ],
    modules:{
        auth,
        sideNav,
        news,
        promotion,
    }
})

export default store
